


























































































import { InstrumentList } from "@/admin/types";
import { DrivewealthAccountManagementType, UserPermission } from "@/shared/types";
import {
  Vue,
  Component,
  Prop,
Watch
} from "@/shared/vuepack";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import FileUpload from "vue-upload-component";
import InstrumentName from "@/shared/components/investments/drivewealth/InstrumentName.vue";
import { Validator } from "vee-validate";
import { useNotifierStore } from "@/shared/store/notifier";
import { useInstrumentListStore } from "@/admin/store/instrumentList";
import { useRolePermissionsStore } from "@/shared/store/rolePermissions";
import { useDrivewealthStore } from "@/shared/store/drivewealth";

@Component({
  components: {
    FileUpload,
    GenericLoadingSpinner,
    InstrumentName
  }
})
export default class InstrumentListVue extends Vue {
  $validator: Validator;
  file = null;
  isSubmitting = false;
  isSubmittingNew = false;
  listId = 0;
  listName = null;
  listDescription = null;
  listInvestmentOption = null;
  currentItems: [];

  @Prop({required: false})
  isCuratedRtq: boolean;

  notifierStore = useNotifierStore();
  instrumentListStore = useInstrumentListStore();
  rolePermissionsStore = useRolePermissionsStore();
  drivewealthStore = useDrivewealthStore();

  @Watch("isCuratedRtq")
  load (): void {
    if (this.isCuratedRtq) {
      this.instrumentListStore.loadCuratedRtqInstrumentLists();
    } else {
      this.instrumentListStore.loadInstrumentLists();
    }
  }

  mounted (): void {
    this.load();
  }

  get pageHeader (): string {
    if (this.isCuratedRtq) {
      return "Manage Select RTQ DriveWealth Instrument Lists";
    }

    return "Manage DriveWealth Instrument Lists";
  }

  get isLoaded (): boolean {
    if (this.isCuratedRtq) {
      return this.instrumentListStore.didLoadCuratedRtqInstrumentLists;
    } else {
      return this.instrumentListStore.didLoadInstrumentLists;
    }
  }

  get isLoading (): boolean {
    if (this.isCuratedRtq) {
      return !this.instrumentListStore.didLoadCuratedRtqInstrumentLists;
    } else {
      return !this.instrumentListStore.didLoadInstrumentLists;
    }
  }

  listFields = [
    {
      key: "listName",
      thClass: "text-left pl-2",
      tdClass: "pl-2",
      label: "Name"
    },
    {
      key: "listDescription",
      label: "Description",
      thClass: "text-left",
      tdClass: "text-left"
    },
    {
      key: "listInvestmentOption",
      label: "Investment Option",
      thClass: "text-left",
      tdClass: "text-left"
    },
    {
      key: "upload",
      label: "",
      thClass: "text-center",
      tdClass: "text-center"
    },
    {
      key: "download",
      label: "",
      thClass: "text-center",
      tdClass: "text-center"
    }
  ];

  investmentOptions = [
    { value: DrivewealthAccountManagementType.Advisory, text: "Select" },
    { value: DrivewealthAccountManagementType.OpenBrokerage, text: "Choice" }
  ];

  get instrumentLists (): any {
    if (this.isCuratedRtq) {
      return this.instrumentListStore.curatedRtqInstrumentLists;
    } else {
      return this.instrumentListStore.instrumentLists;
    }
  }

  selectListId (id: number): void {
    this.instrumentListStore.downloadInstrumentList(id);
  }

  toggleDetails (row): void {
    if (row && row.detailsShowing) {
      row.toggleDetails();
    } else {
      this.currentItems.forEach(item => {
        this.$set(item, "_showDetails", false);
      });
      this.$nextTick(() => {
        row.toggleDetails();
        row.selectRow();
        this.listId = row.item.listId;
        this.file = null;
      });
    }
  }

  get submitDisabled (): boolean {
    return this.isSubmitting || !this.file;
  }

  submit (): void {
    if (!this.file) return;
    if (this.listId === 0) return;
    if (this.isSubmitting) return;

    this.isSubmitting = true;

    this.instrumentListStore.processInstrumentListFile({
      instrumentListId: this.listId,
      csv: this.file
    })
      .then(() => {
        if (this.isCuratedRtq) {
          this.instrumentListStore.loadCuratedRtqInstrumentLists();
        } else {
          this.instrumentListStore.loadInstrumentLists();
        }
      })
      .finally(() => {
        this.isSubmitting = false;
        this.file = null;
      });
  }

  submitNew (): void {
    this.$validator.validateAll()
      .then(isValid => {
        if (!isValid) {
          return;
        }
        this.isSubmittingNew = true;
        const instrumentList: InstrumentList = {
          listName: this.listName,
          listDescription: this.listDescription,
          listInvestmentOption: this.listInvestmentOption,
          isDefault: false,
          count: 0,
          listId: 0
        };
        this.instrumentListStore.createInstrumentList(instrumentList)
          .then(() => {
            this.notifierStore.setSuccess(this.listName + " successfully created");
          })
          .finally(() => {
            this.listName = null;
            this.listDescription = null;
            this.isSubmittingNew = false;
            this.$validator.reset();
          });
      });
  }

  get hasEditPermission (): boolean {
    return this.rolePermissionsStore.userHasAdminPermission(UserPermission.AdminPortalUtilityDrvWealthInstrLstEdit);
  }
}
